import React, { Component } from 'react';
import PasswordForm from '../PasswordForm';

class ModalContent extends Component {
	constructor(props) {
		super(props);
		this.state = {
		}
	}

	render() {
		return (
			<PasswordForm closeModal={() => this.props.closeModal()}></PasswordForm>
		);
	}
}

export default ModalContent;



// WEBPACK FOOTER //
// ./components/PasswordManager/ModalContent.js